import { FC, useState } from "react";
import { useSubject } from "../../../util/useSubject";
import {
  AttachmentDialog,
  AttachmentDialogProps,
} from "../attachment-dialog/AttachmentDialog";
import {
  attachmentDialogClosed,
  AttachmentDialogCloseData,
  attachmentDialogOpened,
} from "../attachment-dialog/AttachmentDialogService";

/**
 * This component is used to facilitate spawning new react dialogs
 * from the legacy angularjs application.
 */
export const LegacyDialogConnector: FC = () => {
  /** Controls whether the attachment dialog is rendered at all */
  const [renderAttachmentDialog, setRenderAttachmentDialog] = useState(false);
  /** Props to render the attachment dialog with */
  const [attachmentDialogProps, setAttachmentDialogProps] =
    useState<AttachmentDialogProps | null>(null);
  /** Data to be sent w/ the next attachment dialog close notification. */
  const [attachmentDialogCloseData, setAttachmentDialogCloseData] =
    useState<AttachmentDialogCloseData>({ uploads: [] });

  useSubject(attachmentDialogOpened, (openOptions) => {
    setAttachmentDialogProps({
      ...openOptions,
      open: true,
      skipCreatingAttachments: openOptions.entityIds === undefined,
    });
    setRenderAttachmentDialog(true);
  });

  // When the dialog isn't being shown, we don't render it at all
  // to forcibly reset the state of the dialog
  return renderAttachmentDialog && attachmentDialogProps ? (
    <AttachmentDialog
      {...attachmentDialogProps}
      TransitionProps={{
        onExited: () => {
          setRenderAttachmentDialog(false);
          setAttachmentDialogProps(null);
          attachmentDialogClosed.next(attachmentDialogCloseData);
          setAttachmentDialogCloseData({ uploads: [] });
        },
      }}
      onClose={(uploads) => {
        setAttachmentDialogCloseData({ uploads });
        setAttachmentDialogProps((props) => {
          if (!props) {
            return props;
          }
          return { ...props, open: false };
        });
      }}
    />
  ) : (
    <></>
  );
};
